import { api as wiredApi } from './index';

/**
 * The orders from the app before InGo, kept as history (ingo-e0, 2 Oct 2026;
 * InGo ADR 0034, Rio: "History only"): what each was, how it ended and its
 * fare as the old system recorded it. Never a delivery, never in the
 * earnings or what a rider owes. Newest first, a page at a time.
 *
 * Built from its client so a test can hand it a fake; `pastOrdersApi` is the
 * wired copy.
 */
export function createPastOrders({ api }) {
  const page = async (path, cursor) => {
    const { data, meta } = await api.get(path, cursor ? { query: { cursor } } : undefined);

    return { orders: Array.isArray(data) ? data : [], next: meta?.cursor?.next ?? null };
  };

  return {
    /** `GET customer/me/past-orders`: the signed-in client's. */
    client: (cursor = null) => page('/customer/me/past-orders', cursor),

    /** `GET rider/me/past-orders`: the signed-in rider's. */
    rider: (cursor = null) => page('/rider/me/past-orders', cursor),
  };
}

export const pastOrdersApi = createPastOrders({ api: wiredApi });
